const otherCertificationTypes = [
  {"value": "", "label": ""},
  {"value":"ACLS", "label":"ACLS"},
  {"value":"BLS", "label":"BLS"},
  {"value":"COLLABORATIVE_PLAN", "label":"Collab. Plan"},
  {"value":"CDS", "label":"CDS"},
  {"value": "DEA", "label": "DEA"},
  {"value": "DRIVERS_LICENSE", "label": "Driver's Lic."},
  {"value": "PALS", "label": "PALS"},
  {"value": "PASSPORT", "label": "Passport"},
  {"value":"TEST", "label":"Test"},
];

export default otherCertificationTypes;